import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SocialWidget.module.scss';

const SocialWidget: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.social_widget}>
      <a
        href="https://www.instagram.com/explore/tags/optimalprint/"
        target="_blank"
        rel="noreferrer"
        className={styles.link}
      >
        <div className={styles.icon} />
        <span className={styles.text}>{t('txt_share_on_instagram')}</span>
      </a>
    </div>
  );
};

export default SocialWidget;
